import { differenceInMonths, isSameDay } from "date-fns";

export const useTickFormat = (start?: Date, end?: Date) => {
  if (!start && !!end) return "MM''yy";
  if (!start) return "MM''yy";
  if (!end) return "MM''yy";

  if (isSameDay(start, end)) {
    return "HH:mm";
  }

  const monthDiff = differenceInMonths(end, start);

  if (monthDiff < 10) {
    return "dd.MM''yy";
  }

  return "MM''yy";
};
